import { disciplines } from "../data/projects";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {disciplines.map((d, i) => (
      <span key={d} className="flex items-center">
        <span className={`px-6 md:px-10 ${i % 2 ? "font-serif italic font-normal tracking-[-0.01em]" : "font-display font-semibold tracking-[-0.045em]"}`}>{d}</span>
        <span className="h-3 w-3 rotate-45 bg-accent md:h-4 md:w-4" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="overflow-hidden border-y border-ink bg-paper py-6 md:py-10" data-testid="discipline-marquee" aria-label="Disciplines">
    <div className="marquee flex w-max text-5xl leading-none text-ink md:text-8xl">
      <Row />
      <Row />
    </div>
  </section>
);
